import { render, staticRenderFns } from "./CSVPreview.vue?vue&type=template&id=aae6125a"
import script from "./CSVPreview.vue?vue&type=script&lang=ts"
export * from "./CSVPreview.vue?vue&type=script&lang=ts"
import style0 from "./CSVPreview.vue?vue&type=style&index=0&id=aae6125a&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports